import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import VeeValidate from 'vee-validate';
import '../sass/app.scss';

import _ from 'lodash';

import VueTippy from 'vue-tippy';
import CustomEventPolyfill from './polyfills/CustomEvent';
import ServiceLevel from './enum/service-levels';
import ApiService from './services/api.service';

// Components
import AppHeader from './components/partials/header.vue';
import AppAlert from './components/partials/alert.vue';
import AppRecords from './components/pages/records.vue';
import AppRecord from './components/pages/record.vue';
import AppInbox from './components/pages/inbox.vue';
import AppProfile from './components/pages/profile.vue';
import AppRegister from './components/pages/auth/register.vue';
import AppRegisterV2 from './components/pages/auth/registerV2.vue';
import AppRegisterToken from './components/pages/auth/registerToken.vue';

require('bootstrap');

// noinspection JSUnresolvedFunction
Vue.use(VeeValidate);
library.add(fas);

// eslint-disable-next-line no-console
Vue.prototype.$log = console.log.bind(console);

Vue.use(VueTippy, {
  flipDuration: 0,
  size: 'large',
  arrow: true,
});

Vue.mixin({
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      ApiService: new ApiService(),
    };
  },
  computed: {
    currentUser() {
      return ApiService.getCurrentUser() || {};
    },
    serviceLevelPaid() {
      return this.$root.serviceLevel === ServiceLevel.PAID;
    },
  },
  methods: {
    imgUri(aImg) {
      const img = aImg || '';
      return this.baseUrl(`images/${img}`, true);
    },
    baseUrl(aPath, actual) {
      const path = aPath || '';

      let url = _.trimEnd(window.backendConfig.jct_app.base_url, '/');
      url += (!actual && this.$root.customerVersion === 1) ? `/${this.$root.groupSlug}` : '';
      url += `/${_.trim(path, '/')}`;

      return url;
    },
    themeUrl(path) {
      let url = _.trimEnd(window.backendConfig.jct_app.base_url, '/');
      url += `/${this.$root.groupSlug}`;
      url += `/${_.trim(path, '/')}`;

      return url;
    },
    themeCssUrl(path) {
      let url = _.trimEnd(window.backendConfig.jct_app.base_url, '/');
      url += `/theme/${this.$root.groupSlug}`;
      url += `/${_.trim(path, '/')}`;

      return url;
    },
    removeItem(item, list) {
      return _.filter(list, (listItem) => !_.isEqual(listItem, item));
    },
    alertBox(attr) {
      const app = this;
      return new Promise((resolve, reject) => {
        app.$root.alertOptions = attr;
        app.$root.alertShow = true;
        document.addEventListener('alertClose', () => {
          app.$root.alertShow = false;
          resolve(true);
        });
        document.addEventListener('alertConfirm', (e) => {
          resolve(e.detail || true);
          app.$root.alertShow = false;
        });
        document.addEventListener('alertCancel', () => {
          app.$root.alertShow = false;
          reject(new Error());
        });
      });
    },
  },
});

window.app = new Vue({
  el: '#app',
  components: {
    AppHeader,
    AppAlert,
    AppRecords,
    AppRecord,
    AppInbox,
    AppProfile,
    AppRegister,
    AppRegisterV2,
    AppRegisterToken,
  },
  data() {
    return {
      alertOptions: {},
      alertShow: false,
      groupSlug: null,
      serviceLevel: null,
      customerVersion: null,
      customerId: null,
    };
  },
  beforeMount() {
    this.groupSlug = this.$el.attributes['data-group-slug'].value;
    this.serviceLevel = this.$el.attributes['data-service-level'].value;
    this.customerVersion = parseInt(this.$el.attributes['data-customer-version'].value, 10);
    this.customerId = parseInt(this.$el.attributes['data-customer-id'].value, 10);
    CustomEventPolyfill();
  },
  methods: {
    dispatch(event, data) {
      const payload = (data) ? { detail: data } : undefined;
      document.dispatchEvent(
        new CustomEvent(event, payload),
      );
    },
  },
});
